import React from 'react';
import { withFormik } from 'formik';

const withVericationForm = (formikConfig, fields) => {
  return Component => {
    class WrappedForm extends React.Component {
      componentDidMount() {
        this.props.onRef(this.props.documentId, this);
      }

      componentWillUnmount() {
        this.props.onRef(undefined);
      }

      handleChange = (documentId, name, value) => {
        if (name === 'amountInEuros') {
          if (value && !/^\d+(\.\d{0,2})?$/.test(value)) return;
        }
        this.props.setFieldValue(name, value);
        this.props.onDataChange(documentId, name, value);
      };

      handleBlur = name => {
        this.props.setFieldTouched(name, true);
      };

      validateForm = () => {
        fields.forEach(fieldName => {
          this.props.setFieldTouched(fieldName, true);
        });
        this.props.validateForm();
      };

      isInputDisabled = valuesToValidate => {
        const forValidation = valuesToValidate;
        const invalid = forValidation.filter(el => !el);
        return invalid.length === 0 ? false : true;
      };

      render = () => {
        return (
          <Component
            onChange={this.handleChange}
            onBlur={this.handleBlur}
            onValidate={this.validateForm}
            isInputDisabled={this.isInputDisabled}
            {...this.props}
          />
        );
      };
    }

    return withFormik(formikConfig)(WrappedForm);
  };
};

export default withVericationForm;



// WEBPACK FOOTER //
// ./src/component/verification_forms/withVericationForm.js